import { cn } from "../../../lib/utils";
import SkillIcon from "./SkillIcon";

const DesignPlanningMarquee = ({
  icon,
  img,
  name,
  category,
  username,
  body,
}: {
  icon?: JSX.Element;
  img?: string;
  name: string;
  category: string;
  username: string;
  body: string;
}) => {
  return (
    <figure
      className={cn(
        "relative h-full w-fit sm:w-36 cursor-pointer overflow-hidden rounded-xl border p-4",
        "border-gray-950/[.1] bg-gray-950/[.01] hover:bg-gray-950/[.05]",
        "dark:border-gray-50/[.1] dark:bg-gray-50/[.10] dark:hover:bg-gray-50/[.15]"
      )}
    >
      <div className="flex flex-row items-center gap-2">
        <SkillIcon icon={icon} img={img} name={name} />
        <div className="flex flex-col items-start">
          <figcaption className="text-sm text-left font-bold dark:text-white">
            {name}
          </figcaption>
          <span className="text-xxs inline-block py-1 px-2.5 leading-none text-left font-bold bg-blue-600 text-white rounded">
            {category}
          </span>
        </div>
      </div>
      <blockquote
        className="mt-1 text-xs font-medium text-left"
        dangerouslySetInnerHTML={{ __html: body }}
      ></blockquote>
    </figure>
  );
};

export default DesignPlanningMarquee;
